export default {
  list: '/ygsjzs/yxIncomeTransfer/list',
  detail: '/ygsjzs/yxIncomeTransfer/detail',
  apply: '/ygsjzs/yxIncomeTransfer/apply',
  approve: '/ygsjzs/yxIncomeTransfer/approve',
  cancel: '/ygsjzs/yxIncomeTransfer/cancel',
  exportPdf: '/ygsjzs/yxIncomeTransfer/exportPdf'
}
